import images from './images';

export default [
  {
    id: '6180fa03b2569b001f9dde16',
    createdOn: '2021-11-02T08:42:43.737Z',
    title: 'Lowest Commission!',
    priority: 3,
    description: 'All Yours! We Take Almost Nothing!',
    slug: 'lowest-commission',
    imageUrl: images.lowestCommissionContestIcon,
    isDeleted: false
  },
  {
    id: '618123a9b2569b001f9dde31',
    createdOn: '2021-11-02T11:40:25.749Z',
    title: 'LEAGUE FOR CHAMPIONS',
    priority: 6,
    description: 'League for Champion',
    slug: 'league-for-champions',
    imageUrl: images.headToHeadContestIcon,
    isDeleted: false
  },
  {
    id: '618155e4b2569b001f9dde56',
    createdOn: '2021-11-02T15:14:44.785Z',
    title: 'HOT CONTESTS',
    priority: 5,
    description: 'Category Test 1',
    slug: 'hot-contests',
    imageUrl: images.headToHeadContestIcon,
    isDeleted: false
  },
  {
    id: '618155f4b2569b001f9dde57',
    createdOn: '2021-11-02T15:15:00.435Z',
    title: 'Category Test 2',
    priority: 201,
    description: 'Category Test 2',
    slug: 'category-test-2',
    imageUrl: 'https://images-v1.igamio.com/contest-category/2X.png',
    isDeleted: false
  },
  {
    id: '618156d9b2569b001f9dde59',
    createdOn: '2021-11-02T15:18:49.093Z',
    title: 'Contest Category 3',
    priority: 130,
    description: 'Contest Category 3',
    slug: 'contest-category-3',
    imageUrl: 'https://images-v1.igamio.com/contest-category/2X.png',
    isDeleted: false
  },
  {
    id: '618156ecb2569b001f9dde5a',
    createdOn: '2021-11-02T15:19:08.854Z',
    title: 'Contest Category 4',
    priority: 170,
    description: 'Contest Category 4',
    slug: 'contest-category-4',
    imageUrl: 'https://images-v1.igamio.com/contest-category/2X.png',
    isDeleted: false
  },
  {
    id: '61817455b2569b001f9dded3',
    createdOn: '2021-11-02T17:24:37.862Z',
    title: '100% Bonus',
    priority: 2,
    description: 'Bonus',
    slug: '100-bonus',
    imageUrl: images.hundredPercentBonusContestIcon,
    isDeleted: false
  },
  {
    id: '618176c3b2569b001f9dded6',
    createdOn: '2021-11-02T17:34:59.220Z',
    title: '2 Winners Out Of 3!',
    priority: 4,
    description: 'Less Pain! More Gain!',
    slug: '2-winners-out-of-3',
    imageUrl: 'https://images-v1.igamio.com/contest-category/2winners.png',
    isDeleted: false
  },
  {
    id: '61817f8fb2569b001f9ddedd',
    createdOn: '2021-11-02T18:12:31.337Z',
    title: 'Grand League',
    priority: 0,
    description: 'Grand League',
    slug: 'grand-league',
    imageUrl: images.grandLeagueContestIcon,
    isDeleted: false
  },
  {
    id: '61821df3b2569b001f9ddf4f',
    createdOn: '2021-11-03T05:28:19.484Z',
    title: 'Multiple Player One Entry ',
    priority: 40,
    description: 'one entry',
    slug: 'multiple-player-one-entry-',
    imageUrl: images.headToHeadContestIcon,
    isDeleted: false
  },
  {
    id: '61821e0cb2569b001f9ddf50',
    createdOn: '2021-11-03T05:28:44.369Z',
    title: 'Multiple Player Multiple Entry',
    priority: 600,
    description: 'Multiple Entry',
    slug: 'multiple-player-multiple-entry',
    imageUrl: images.headToHeadContestIcon,
    isDeleted: false
  },
  {
    id: '61824b91b2569b001f9de06d',
    createdOn: '2021-11-03T08:42:57.866Z',
    title: 'Tahalka League!!',
    priority: 7,
    description: '20 Crores!',
    slug: 'tahalka-league',
    imageUrl: images.headToHeadContestIcon,
    isDeleted: false
  },
  {
    id: '618284340d1e16001ef3297e',
    createdOn: '2021-11-03T12:44:36.448Z',
    title: 'Giveaway',
    priority: 1,
    description: 'Giveaway League',
    slug: 'giveaway',
    imageUrl: images.giveawayContestIcon,
    isDeleted: false
  },
  {
    id: '6184eaa40d1e16001ef32995',
    createdOn: '2021-11-05T08:26:12.739Z',
    title: 'Practice Contest',
    priority: 8,
    description: 'Know The Fantasy Game!',
    slug: 'practice-contest',
    imageUrl: images.headToHeadContestIcon,
    isDeleted: false
  },
  {
    id: '626bfd0be20b04001f1b0008',
    createdOn: '2022-04-29T14:58:19.997Z',
    title: 'Rangerr',
    priority: 13,
    description: 'Ranger_fast',
    slug: 'rangerr',
    imageUrl: '',
    isDeleted: false
  },
  {
    id: '631301f38977f2001ed3422e',
    createdOn: '2022-09-03T07:27:47.889Z',
    title: 'Head To Head',
    priority: 19,
    description: 'head to head',
    slug: 'head-to-head',
    imageUrl: images.headToHeadContestIcon,
    isDeleted: false
  }
];
